// handle split subheading text and trigger reveal text animation
(() => {
  const splitTexts = document.querySelectorAll('.anim--splitText');
  function wrapTextInSpans(text) {
    return text.split('').map((char, index) => `<span class="_char" style="transition-delay:${((index+1)/10)/2}s"><span>${char}</span></span>`).join('');
  }

  if(splitTexts) {
    splitTexts.forEach(splitText => {
      const ANIM_DELAY = 0.1;

      const spHeading = splitText.closest('.sp-heading');
      const spHeadingMain = spHeading.querySelector('.sp-heading__main');
      const spHeadingIntro = spHeading.querySelector('.sp-heading__intro');
      const spHeadingBorder = spHeading.querySelector('.sp-heading__border');

      const text = splitText.innerText;
      if(text.length > 0) {
        const wrappedText = wrapTextInSpans(text);
        splitText.innerHTML = wrappedText;

        const _lastChar = spHeading.querySelector('._char:last-child');
        const _lastCharDelay = _lastChar.style.transitionDelay;
        const _lastCharDelayNumber = Number(_lastCharDelay.split('s')[0]);

        if(spHeadingMain) {
          spHeadingMain.setAttribute('style', `transition-delay: ${_lastCharDelayNumber + ANIM_DELAY}s`);
        }
        
        if(spHeadingIntro) {
          spHeadingIntro.setAttribute('style', `transition-delay: ${_lastCharDelayNumber + (ANIM_DELAY*2)}s`);
        }

        if(spHeadingBorder) {
          spHeadingBorder.setAttribute('style', `transition-delay: ${_lastCharDelayNumber}s`);
        }
      }
    })
  }
})();

// trigger animation for every animation as well as background section
(() => {
  window.addEventListener('load', () => {
    const { inView } = window.SP.libs;

    inView.threshold(0.7);
    inView('.anim')
    .on('enter', el => {
      el.classList.add('anim--active');
    });

    inView.threshold(0.2);
    inView('.anim-section')
    .on('enter', el => {
      const background = el.getAttribute('data-background');
      const color = el.getAttribute('data-color');

      document.body.style.backgroundColor = background;
      el.style.color = color;
      el.classList.add('anim-section--active');

    })
    .on('exit', el => {
      document.body.style.backgroundColor = 'rgb(var(--color-background))';
      el.style.color = 'revert';
      el.classList.remove('anim-section--active');
    })
    ;
  });
})();

// window.addEventListener("load", () => {
//   // Select all img elements on the page
//   const images = document.querySelectorAll("img");

//   images.forEach((img) => {
//     // Wait for each image to load to get its natural dimensions
//     img.onload = () => {
//       img.setAttribute("width", img.naturalWidth);
//       img.setAttribute("height", img.naturalHeight);
//     };

//     // Set the src if the images are dynamically added or ensure they load
//     if (!img.complete) {
//       img.src = img.src; // Reload the image to ensure the onload event triggers
//     } else {
//       // If already loaded, set the dimensions immediately
//       img.setAttribute("width", img.naturalWidth);
//       img.setAttribute("height", img.naturalHeight);
//     }
//   });
// });
